"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditIcon = void 0;
const react_1 = require("react");
const React = require("react");
const icon_1 = require("./icon");
class EditIcon extends react_1.Component {
    render() {
        const { fill = icon_1.ICON_COLORS.fill } = this.props;
        return (React.createElement("svg", { width: "24px", height: "24px", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" },
            React.createElement("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
                React.createElement("g", { fill: fill },
                    React.createElement("g", { id: "Group", transform: "translate(5.000000, 5.000000)" },
                        React.createElement("path", { d: "M0.395033333,13.622875 C0.482533333,13.710375 0.615533333,13.734875 0.731616667,13.6777083 L3.8437,12.1219583 L1.89653333,10.1742083 L0.3402,13.2862917 C0.2842,13.398875 0.306366667,13.5342083 0.395033333,13.622875" }),
                        React.createElement("path", { d: "M12.922175,3.15851667 L13.5410917,2.5396 C14.1098417,1.97085 14.1098417,1.04568333 13.5410917,0.477516667 C13.265175,0.202766667 12.899425,0.0499333333 12.5097583,0.0499333333 C12.1200917,0.0499333333 11.7537583,0.202766667 11.478425,0.477516667 L10.8595083,1.09585 L12.922175,3.15851667 Z" }),
                        React.createElement("polygon", { points: "4.31345833 11.76665 12.509875 3.57081667 10.4472083 1.50873333 2.251375 9.70456667" }))))));
    }
}
exports.EditIcon = EditIcon;



//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/edit.tsx
// module id = 511
// module chunks = 0 1 2